import React from 'react';
import { DownloadIcon, UploadIcon } from './Icons';
import { PO_CONVERSION_CONFIG } from '../constants/purchasingConfig';

const ShoppingCartIcon = () => (
  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
  </svg>
);

const LightningIcon = ({ className = "w-4 h-4" }) => (
  <svg className={className} viewBox="0 0 24 24" fill="currentColor">
    <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
  </svg>
);

const PurchasingModePanel = ({
  poFilter,
  onOpenPoFilterBuilder,
  loading,
  isInspecting,
  onLoadPOLines,
  onPreviewPOCreate
}) => {
  return (
    <div className="bg-gray-800 p-4 rounded shadow-sm border border-amber-500/30 mb-6">
      <div className="flex items-center gap-2 mb-4 text-amber-400 bg-amber-500/10 p-2 rounded border border-amber-500/20">
        <ShoppingCartIcon />
        <span className="text-xs font-bold uppercase">PO Conversion</span>
      </div>
      
      <div className="mb-4">
        <p className="text-sm text-gray-300 mb-3">
          Load PO Document Entry lines for conversion. Data will be formatted with the columns needed for creating new purchasing transactions.
        </p>
        
        <div className="bg-amber-500/10 border border-amber-500/20 rounded p-3 mb-4">
          <p className="text-xs font-bold text-amber-400 mb-1">Output Columns:</p>
          <p className="text-xs text-amber-300/70">
            {PO_CONVERSION_CONFIG.outputColumns.map(c => c.name).join(', ')}
          </p>
        </div>
      </div>
      
      <div className="mb-4">
        <label className="block text-xs font-bold text-gray-400 uppercase mb-1">Filter PO Lines</label>
        <div className="flex gap-2">
          <input 
            type="text" 
            readOnly 
            value={poFilter} 
            className="flex-1 p-2 border border-gray-600 rounded text-xs bg-gray-700 text-gray-300 font-mono truncate" 
          />
          <button 
            onClick={onOpenPoFilterBuilder} 
            className="px-3 py-2 bg-gray-600 border border-gray-500 rounded text-xs font-medium text-gray-300 hover:bg-gray-500 shadow-sm"
          >
            Edit
          </button>
        </div>
        <p className="text-[10px] text-gray-500 mt-1">Filter applies to PODOCUMENTENTRY</p>
      </div>
      
      <button 
        onClick={onLoadPOLines} 
        disabled={loading || isInspecting} 
        className="w-full py-3 px-4 bg-amber-500 hover:bg-amber-400 disabled:bg-gray-600 text-gray-900 rounded-md shadow-sm text-sm font-bold flex items-center justify-center gap-2"
      >
        <DownloadIcon /> {loading ? 'Loading...' : '⚡ Load PO Lines'}
      </button>
      
      {isInspecting && (
        <div className="text-[10px] text-amber-400 mt-2 animate-pulse text-center">
          ⚡ Loading PODOCUMENTENTRY schema...
        </div>
      )}
      
      {/* Create Section */}
      <div className="mt-6 pt-4 border-t border-gray-700">
        <div className="flex items-center gap-2 mb-3">
          <LightningIcon className="w-4 h-4 text-green-400" />
          <span className="text-sm font-bold text-green-400">Create PO Transactions</span>
        </div>
        <p className="text-xs text-gray-400 mb-3">
          After loading and editing PO lines, select the data range (with headers) and preview the create operation.
        </p>
        <button 
          onClick={onPreviewPOCreate} 
          disabled={loading} 
          className="w-full py-3 px-4 bg-green-500 hover:bg-green-400 disabled:bg-gray-600 text-gray-900 rounded-md shadow-sm text-sm font-bold flex items-center justify-center gap-2"
        >
          <UploadIcon /> Preview Create
        </button>
      </div>
    </div>
  );
};

export default PurchasingModePanel;